module.exports = __webpack_public_path__ + "static/media/1-6.9fa6a1cd.png";